
export default {
	props: {
		value: {
			type: Array,
			default: () => []
		},
		answers: {
			type: Object,
			default: () => ({})
		},
	},
	data() {
		return {
			isDisabledSelectSecond: true,
			checkboxes: [
				{ 
					title: 'AFF',
					fullTitle: 'Atrial Fibrillation or Atrial Flutter'
				},
				{ 
					title: 'Chronic Kidney Disease',
					fullTitle: 'Chronic Kidney Disease'
				},
				{ 
					title: 'ASCVD',
					fullTitle: 'Atherosclerotic Cardiovascular Disease'
				},
				{ 
					title: 'HF',
					fullTitle: 'Heart Failure'
				},
			],
			selectsSecond: [
				{
					title: 'HFrEF/HFmrEF',
					fullTitle: 'HFrEF/HFmrEF'
				},
				{
					title: 'HFpEF',
					fullTitle: 'Heart Failure with Preserved Ejection Fraction'
				},
			]
		}
	},
	mounted() {
		if (this.answers.questionFirst.includes('HF')) {
			this.isDisabledSelectSecond = false;
		}
	},
	methods: {
		updateStates(currentValue) {
			const answers = this.answers;

			const hasAFForCKD =
				currentValue.includes('AFF') ||
				currentValue.includes('Chronic Kidney Disease');
			const hasASCVD = currentValue.includes('ASCVD');

			const hasHF = currentValue.includes('HF');

			const hfTypeSelected = this.selectsSecond.some(
				opt => currentValue.includes(opt.title)
			);

			answers.isQuestionSecond = hasASCVD || (hasHF && hfTypeSelected);
			answers.isQuestionThird = hasAFForCKD;

			this.isDisabledSelectSecond = !hasHF;
		},
		updateValue(event, option) {
			let newValue = [...this.value];

			if (event.target.checked) {
				if (!newValue.includes(option)) {
					newValue.push(option);
				}
			} else {
				newValue = newValue.filter(o => o !== option);

				if (option === 'HF') {
				    newValue = newValue.filter(val => 
				        val !== 'HFrEF/HFmrEF' && val !== 'HFpEF'
				    );

				    this.$nextTick(() => {
				        if (this.$refs.selectSecond) {
				        	this.$refs.selectSecond.value = 'Make a choice';
				        }
				    });
				}
			}
			
			this.updateStates(newValue);
			this.$emit('input', newValue);
		},
		updateSelectSecond(option) {
			let newValue = this.value.filter(o => o !== 'HFrEF/HFmrEF' && o !== 'HFpEF');
			
			if (option == 'HFrEF/HFmrEF' || option == 'HFpEF') {
				newValue.push(option);
			}
			
			this.updateStates(newValue);
			this.$emit('input', newValue);
		}
	}
}
